<script>
  export default{
    name: 'chat-comitente-resumido',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="chat-resumido-comitente sys-table">
    <div class="chat-content">
      <!--<div class="message">
        <strong>AZULSEGUROS</strong> Poderia retornar o leilão do lote 027,
        pois o valor mínimo rejeitado inicialmente foi aprovado pela diretoria. <span>12 segundos atrás</span>
      </div>-->
      <div class="message0 no-select">
        Nenhuma mensagem
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ChatResumidoComitente.vue?59a808ae